export const SET_METAS = "SET_METAS";
export const ADD_PRESTACION = "ADD_PRESTACION"
export const REMOVE_PRESTACION = "REMOVE_PRESTACION"